import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteStaffMemberById } from '../../../../../../../../../actions/staffActions';

export const useRemoveStaff = (id) => {
  const dispatch = useDispatch();

  const [isShowConfirmModal, setShowConfirmModal] = useState(false);

  const onClose = () => {
    setShowConfirmModal(false);
  };

  const onShow = () => {
    setShowConfirmModal(true);
  };

  const onRemoveStaff = () => {
    dispatch(deleteStaffMemberById(id));
    onClose();
  };

  return {
    isShowConfirmModal,
    onCloseConfirmPopup: onClose,
    onShowConfirmPopup: onShow,
    onRemoveStaff,
  };
};
